<script setup lang="ts">
import { CfgPreloader, CfgSlideOver } from '@cfgtech/ui';
import type { PropType } from '@vue/runtime-core';
import type { CompanyId, IssueId } from '@/composables/events/useEvents';

defineProps<{
  companyId: CompanyId | null,
  issueId: IssueId | null,
  entityName?: string,
}>();

defineEmits<{
  'load-more': []
}>();

const responsive = useResponsive();
const { width: screenWidth } = useWindowSize();

const isOpened = defineModel<boolean>('isOpened', {
  type: Boolean as PropType<boolean>,
  default: false
});

useEventListener('hashchange', () => {
  isOpened.value = false;
});
</script>

<template>
  <CfgSlideOver
    v-model:opened="isOpened"
    class="news-slideOver"
    :description="entityName"
    :title="$t('events.eventList.news')"
    v-bind="{
      ...(!responsive.mobile ? { width: screenWidth < 800 ? '80vw' : '50vw' } : {})
    }"
  >
    <Suspense>
      <div class="w-full max-w-[560px] pb-20 pt-6">
        <EventsList
          :company-id="companyId"
          :issue-id="issueId"
          @event:click="isOpened = false"
        />
      </div>

      <template #fallback>
        <div class="flex items-center justify-center py-20 text-brand">
          <CfgPreloader />
        </div>
      </template>
    </Suspense>
  </CfgSlideOver>
</template>
